"use strict";

var _interopRequireDefault = require("/opt/build/repo/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/opt/build/repo/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.function.name");

var _api = _interopRequireDefault(require("@/api"));

var _config = _interopRequireDefault(require("@/config/config"));

var _table = _interopRequireDefault(require("@/mixin/table"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var listQuery = {
  name: undefined,
  industries: undefined,
  status: undefined,
  startAt: undefined,
  endAt: undefined
};
var _default = {
  name: 'CampaignsList',
  mixins: [_table.default],
  data: function data() {
    return {
      date: [],
      statistics: _config.default.statistics,
      campaignOptions: _config.default.campaignOptions,
      statusOptions: _config.default.statusOptions.filter(function (v) {
        return v.value !== 'draft';
      }),
      brandTypeOptions: _config.default.brandTypeOptions,
      listQuery: this.$_.clone(listQuery),
      loading: false,
      dialogTableVisible: false,
      dialogTitle: '审核结论',
      industriesOptions: {},
      tableItem: {},
      ruleForm: {
        isThrough: 'approved',
        reason: undefined
      },
      rules: {
        isThrough: [{
          message: '请选择',
          trigger: 'change'
        }],
        reason: [{
          required: true,
          message: '请输入驳回意见',
          trigger: 'change'
        }]
      },
      amendments: []
    };
  },
  computed: {
    showPage: function showPage() {
      return this.$route.name === 'CampaignsList';
    }
  },
  created: function created() {
    this.getData();
  },
  methods: {
    toCampaignsDetail: function toCampaignsDetail(item) {
      this.$router.push({
        name: 'campaignsDetail',
        query: {
          id: item._id
        }
      });
    },
    toCooperation: function toCooperation(item) {
      console.log('item', item);
      this.$router.push({
        name: 'cooperation',
        query: {
          id: item._id
        }
      });
    },
    handleOpenTableVisible: function handleOpenTableVisible(item, title) {
      this.dialogTitle = title;
      this.dialogTableVisible = true;
      this.tableItem = item;
      this.$refs['ruleForm'].resetFields();
      this.getCampaignApprovals();
    },
    submitForm: function submitForm(formName) {
      var _this = this;

      if (this.ruleForm.isThrough === 'approved') {
        // alert(4)
        this.patchAudit();
        return;
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.patchAudit();
        }
      });
      this.$refs[formName].resetFields();
    },
    commission: function commission(item) {
      return item.jobSum.totalPaid * item.feeRate || 0;
    },
    getCampaignApprovals: function () {
      var _getCampaignApprovals = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  idCampaign: this.tableItem._id
                };
                _context.next = 3;
                return _api.default.getCampaignApprovals(params);

              case 3:
                res = _context.sent;
                this.amendments = res.data;
                console.log('this.amendments', this.amendments);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCampaignApprovals() {
        return _getCampaignApprovals.apply(this, arguments);
      }

      return getCampaignApprovals;
    }(),
    patchAudit: function () {
      var _patchAudit = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('this.tableItem', this.tableItem);
                data = {
                  content: this.ruleForm.reason,
                  status: this.ruleForm.isThrough,
                  idCampaign: this.tableItem._id
                };
                _context2.prev = 2;

                if (!this.loading) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                this.loading = true;
                _context2.next = 8;
                return _api.default.patchAudit(data);

              case 8:
                res = _context2.sent;
                console.log('res', res); // this.ruleForm.isThrough = 'approved'
                // this.ruleForm.reason = undefined

                this.loading = false;
                this.dialogTableVisible = false;
                this.getList();
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](2);
                this.loading = false;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 15]]);
      }));

      function patchAudit() {
        return _patchAudit.apply(this, arguments);
      }

      return patchAudit;
    }(),
    removeDomain: function removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item);

      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    filterPlatforms: function filterPlatforms(platforms) {
      return platforms.filter(function (platform) {
        return platform !== 'other';
      });
    },
    getData: function getData() {
      if (this.showPage) {
        this.getList();
        this.platformOptions = this.$storage.get('platformOptions');
        this.industriesOptions = this.$storage.get('industriesOptions');
      }
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;
      var params = {
        'status[$ne]': this.listQuery.status ? undefined : 'draft',
        'platforms[$in]': this.listQuery.platforms ? [this.listQuery.platforms] : undefined,
        status: this.listQuery.status,
        keyword: this.listQuery.name,
        $skip: (this.page - 1) * this.limit || 0,
        $limit: this.limit
      };
      params = this.$_.pickBy(params, this.$_.identity);

      _api.default.fetchCampaignsList(params).then(function (res) {
        console.log('res-fetchCampaignsList :', res);
        _this2.listLoading = false;
        _this2.list = res.data;
        _this2.total = res.total;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    handleDate: function handleDate(row) {
      if (this.listQuery.date) {
        this.listQuery.startAt = this.formatUtcDate(this.listQuery.date[0]);
        this.listQuery.endAt = this.formatUtcDate(this.listQuery.date[1]);
      } else {
        this.listQuery.startAt = undefined;
        this.listQuery.endAt = undefined;
      }

      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      this.page = 1;
      this.getList();
    },
    resetForm: function resetForm() {
      this.listQuery = this.$_.clone(listQuery);
      this.handleFilter();
    },
    getCampaignsStatistics: function getCampaignsStatistics() {
      var _this3 = this;

      _api.default.getCampaignsStatistics().then(function (res) {
        _this3.statistics.first.num = res.find(function (i) {
          return i._id === 'inProgress';
        }).count;
        _this3.statistics.second.num = res.find(function (i) {
          return i._id === 'finished';
        }).count;
        _this3.statistics.third.num = res.find(function (i) {
          return i._id === 'cancelled';
        }).count;
      });
    }
  }
};
exports.default = _default;